<template>
  <v-flex xs12 md3>
    <div>
      <!-- <p v-if="isConnected">We're connected to the server!</p> -->
      <!-- <p>Message from server: "{{socketMessageSingle}}"</p> -->
      <!-- <v-btn @click="pingServer()">Ping Server</v-btn> -->
      <!-- <p>Pinging the server...{{ ping }}</p> -->
      <div>
        <!-- <div class="main">
        <div class="btn-group"></div>
        <v-container grid-list-sm>
          <v-form ref="form">
            <v-btn color="success" @click="sendMessage()">Submit</v-btn>
            <v-text-field v-model="sendMessageInput" label="Enter message"/>
          </v-form>
          <div v-if="channelMessages.length > 0" class="message-box">
            <div class="response-box">Socket response</div>
            <v-list>
              <p v-for="message in channelMessages" :key="message">{{ message }}</p>
            </v-list>
          </div>
        </v-container>
        </div>-->
        <div class="logs">
          <div class="logs-header">Event Log</div>
          <div class="logs-box" style="overflow:hidden;height: 350px">
            <!-- <v-list> -->
            <transition-group name="list" tag="p">
              <p v-for="message in socketMessages" :key="message.date" class="socket-msg">
                <template v-if="message.sensorType">
                  <span
                    class="yellow--text text--darken-3"
                  >{{ message.date | moment("MM-DD-YYYY h:mm:ss a") }}</span>
                  --
                  <span style="font-family: courier;">
                    Sensor&nbsp;
                    <span
                      :class="['sensor-type-text-' + message.sensorType]"
                    >{{message.sensorName}}&nbsp;</span>reported.
                  </span>
                </template>
                <template v-else>
                  <span
                    class="yellow--text text--darken-3"
                  >{{ message.date | moment("MM-DD-YYYY h:mm:ss a") }}</span>
                  --
                  <span style="font-family: courier;">{{message.msg}}</span>
                </template>
                <!-- {{ message }} -->
              </p>
            </transition-group>
            <!-- </v-list> -->
          </div>
        </div>
      </div>
    </div>
  </v-flex>
</template>

<script>
import Pusher from "pusher-js";
export default {
  data() {
    return {
      isConnected: false,
      socketMessageSingle: "",
      newWData: "",
      sendMessageInput: "",
      ping: "",
      msgShow: true
    };
  },
  mounted() {
    this.subscribe();
  },

  // sockets: {
  //   connect() {
  //     // Fired when the socket connects.
  //     this.isConnected = true;
  //     this.$store.commit("setSocketConnectionStatus", this.isConnected);
  //     console.log("process.env", process.env);
  //   },

  //   disconnect() {
  //     this.isConnected = false;
  //     this.$store.commit("setSocketConnectionStatus", this.isConnected);
  //   },

  //   },
  //   // Fired when the server sends something on the "newWData Channel" channel.
  //   // NOTE: this can be a string.
  //   "newWData Channel"(data) {
  //     this.newWData = data;
  //   },

  //   pingChannel(data) {
  //     this.ping = data;
  //   }
  // },

  methods: {
    pingServer() {
      // Send the "pingServer" event to the server.
      this.$socket.emit("pingServer", "PING!");
    },
    sendMessage() {
      if (this.sendMessageInput !== "") {
        // this.socketEmitSendMessage(this.sendMessageInput);
        this.$store.commit(
          "pushMessageToSocketMessages",
          this.sendMessageInput
        );
        this.sendMessageInput = "";
      }
    },
    subscribe() {
      // Enable pusher logging - don't include this in production
      // Pusher.logToConsole = true;
      // this is unavailable inside a function, so we set a var self and then call that
      let self = this;
      // Pusher.log = function(message) {
      //   let msg = { "✨debug✨": message };
      //   self.$store.commit("pushMessageToSocketMessages", {
      //     msg: msg,
      //     date: Date.now()
      //   });
      //   // console.log("✨ pusher log message message", message);
      // };

      let pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
        cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
        forceTLS: true
      });

      pusher.connection.bind("connected", function() {
        self.$store.commit("socketOnConnect"); // reusing socketio status fns
        console.log(pusher.connection.state);
      });

      pusher.connection.bind("state_change", function(states) {
        // states = {previous: 'oldState', current: 'newState'}
        let msg = `✨Channels state change from ${states.previous} to ${
          states.current
        }.`;
        self.$store.commit("pushMessageToSocketMessages", {
          msg: msg,
          date: Date.now()
        });
      });

      // console.log("pusher", pusher);

      let channel = pusher.subscribe("messageChannel");

      channel.bind("messageEvent", data => {
        console.log("pusher data", data);
        self.$store.commit("pushMessageToSocketMessages", data);
      });

      channel.bind("sensorReadingEvent", data => {
        console.log("sensor reading", data);

        self.$store.commit("sensorReading", data);
      });
    }
  },
  computed: {
    socketMessages: function() {
      // console.log(this.$store.state.socketMessages);
      return this.$store.state.socketMessages;
    },
    connected: function() {
      return this.$store.state.connected;
    },
    channelMessages: function() {
      console.log(this.$store.state.channelMessages);
      return this.$store.state.channelMessages;
    }
  }
};
</script>

<style>
@keyframes pulse {
  0% {
    background-color: none;
  }
  50% {
    background-color: rgba(251, 255, 6, 0.2);
  }
  100% {
    background-color: none;
  }
}

.list-enter-active {
  transition: all 1s;
  animation: pulse 1s;
  /* background-color: aqua; */
  /* transition-property: background-color 0.3s ease-in-out; */
}
.list-leave-active {
  transition: all 1s ease-in-out;
  background-color: tomato;
  transition: background-color 1s linear;
}
.socket-msg {
  margin: 5px;
  /* font-family: monospace; */
  font-size: x-small;
}
</style>